import React, { ReactNode } from "react";
import "../App.css"

interface FullWindowContainerWithScrollableContentProps {
    topBarContent: ReactNode;                      // anything — image, video, etc.
    children?: ReactNode;                       // overlay content
}

const FullWindowContainerWithScrollableContent: React.FC<FullWindowContainerWithScrollableContentProps> = (props: FullWindowContainerWithScrollableContentProps) => {
    return (
        <div className={"page"}>
            <div className={"topbar"}>
                {props.topBarContent}
            </div>
            <div className="scrollArea">
                {props.children}
            </div>
        </div>

    );
};

export default FullWindowContainerWithScrollableContent;
